/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminGetDocumentTypes } from '../fn/document-type-controller/admin-get-document-types';
import { AdminGetDocumentTypes$Params } from '../fn/document-type-controller/admin-get-document-types';
import { DocumentTypeWithRelations } from '../models/document-type-with-relations';

@Injectable({ providedIn: 'root' })
export class DocumentTypeControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentTypeControllerAdminGetDocumentTypes()` */
  static readonly DocumentTypeControllerAdminGetDocumentTypesPath = '/admin/document-types';

  /**
   * Get all document types
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminGetDocumentTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminGetDocumentTypes$Response(params?: AdminGetDocumentTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentTypeWithRelations>>> {
    return adminGetDocumentTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all document types
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminGetDocumentTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminGetDocumentTypes(params?: AdminGetDocumentTypes$Params, context?: HttpContext): Observable<Array<DocumentTypeWithRelations>> {
    return this.adminGetDocumentTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DocumentTypeWithRelations>>): Array<DocumentTypeWithRelations> => r.body)
    );
  }

}
